import { normalizeUrl } from "@/lib/utils";
import type { ClubSource } from "@/types/discover";

export function hasClubCallToAction(
  club: Pick<ClubSource, "is_spond_club" | "signup_url" | "contact_email">,
): boolean {
  return club.is_spond_club
    ? !!normalizeUrl(club.signup_url)
    : !!club.contact_email;
}
